<template>
  <div v-if="isShow" class="showpage" @click="close()" >
    <div class="showpageinfo" @click.stop>
      <popup-phone v-if="type==1"></popup-phone>
      <popup-mail v-if="type==2"></popup-mail>
    </div>
  </div>
</template>
  <script>
import { mapGetters } from 'vuex';
import PopupMail from './PopupMail.vue';
import PopupPhone from "./PopupPhone.vue";
export default {
  components: { PopupPhone, PopupMail },
  data() {
    return {
    };
  },
  props:{
    type:{
      type: Number,
      default: 1
    },
    isShow:{
      type: Boolean,
      default: false
    }
  },
  mounted() {},
  methods: {
    close() {
      this.$emit('update:isShow',false);
    },
  },
  computed:{
      ...mapGetters(['UserMail','UserPhone']),
  },
   watch: {
    UserMail(val, oldval) {
      this.close();
    },
    UserPhone(val, oldval){
      this.close();
    }
  },
};
</script>
  <!--声明语言，并且添加scoped-->
<style  scoped>
.showpage {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200;
}
.showpageinfo {
  position: absolute;
  left: calc(50% - 318px);
  top: calc(50% - 157px);
  width: 400px;
  height: 230px;
  background-color: #fff;
  z-index: 201;
  border-radius: 10px;
  padding: 0 87px;
  padding-top: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/user/Popup.vue